import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';

export const DATE_VALUES = {
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY'
  },
};

@Component({
  selector: 'insert-edit-date',
  templateUrl: './date.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DATE_VALUES },
    { provide: DateAdapter, useClass: MomentDateAdapter }
  ]
})
export class DateComponent implements OnInit {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;
  disabled: boolean = false;

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit() {
    this.disabled = this.getFormControlField()?.disabled || false;
    const v = this.getFormControlField()?.value;

    if(v !== null && v !== '') {
      this.getFormControlField()?.setValue(moment(v, 'DD/MM/YYYY'));
    }
  }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  clearField() {
    this.getFormControlField()?.setValue(null);
  }
}
